import apiServices from '@/shared/services/api/axios'

const CountAccessService = {
    apiGetListCountAccess(payload: any) {
        let url = 'provider/count-access-provider'

        if (payload) {
            let index = 0
            for (const key in payload) {
                if (payload[key]) {
                    if (!index) {
                        url += `?${key}=${payload[key]}`
                    }
                    if (index) {
                        url += `&${key}=${payload[key]}`
                    }
                    index++
                }
            }
        }
        return apiServices.get(url)
    }
}
export default CountAccessService
